<template>
  <div class="col-12 page_content_area">
    <div class="container enterprises_content_area">
      <intern-form ref="intern_form" :hidden="isEmpty && editType == 'view'" :edit-type="editType" :form-title="formTitle"
        :form-type="formType" :blueprint="blueprint"
        :backPath="`/teachers/intern-record/${this.$route.params.year}/${this.$route.params.eid}/${this.$route.params.sid}`"
        @load="load" @submitData="submitData" @downloadPdf="downloadPdf" @printPdf="printPdf" />
      <iframe id="print" style="display: none;"></iframe>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import InternForm from '~components/common/forms/InternForm'
import { enter_area } from '~components/common/enter_area.js'
import { InternPlanFormBlueprint } from '~components/common/forms/blueprints/InternPlanForm.js'
import { InternPlanFormFormat } from '~components/common/forms/form_format/InternPlanForm.js'
import {
  blueprint_form_data_to_str_form_data,
  create_new_window_cnt,
  create_pdf_data_url,
} from '~components/common/forms/blueprint_form_pdf.js'
import { downloadPdf } from '~api/pdf'
import { getDeptOptions, getYearOptions } from '~components/common/forms/UniversalOptions.js'
export default {
  name: 'InternPlanFormContent',
  components: {
    InternForm,
  },
  props: {
    editType: {
      type: String,
      default: ''
    },
  },
  computed: {
    ...mapGetters('pages/teachers', [
      'currentInternFormGetter',
      'currentInternRecordListGetter',
    ]),
    blueprint() {
      return InternPlanFormBlueprint;
    }
  },
  data() {
    return {
      formTitle: '校外實習計畫表',
      formType: 'intern_plan_form',
      internContentPlanEnterArea: [],
      internContentPlanOuterEl: null,
      isEmpty: true,
      dept: {},
    };
  },
  methods: {
    ...mapActions('layouts', [
      'newToast',
      'togglePageLoader',
    ]),
    ...mapActions('pages/teachers', [
      'sendInternForm',
      'getInternForm',
      'getInternRecordList'
    ]),
    getInternContentPlanList() {
      let intern_content_plan = this.internContentPlanEnterArea
        .filter(plan_enter_area => plan_enter_area)
        .map(plan_enter_area => plan_enter_area.get_form_data())
        .filter(plan_form_data => Object.keys(plan_form_data).length == 4);
      return intern_content_plan;
    },
    async submitData(form_data) {
      form_data.intern_content_plan = this.getInternContentPlanList();
      if (form_data.intern_content_plan.length == 0) {
        this.newToast({
          variant: 'warning',
          message: '實習課程內容規劃需至少一項'
        });
        return;
      }
      this.togglePageLoader(true);
      await this.sendInternForm({
        type: this.formType,
        params: {
          year: this.$route.params.year,
          enterprise_id: this.$route.params.eid,
          student_id: this.$route.params.sid,
          form: form_data,
        },
      }).then((result) => {
        this.$router.push({ path: `/teachers/intern-record/${this.$route.params.year}/${this.$route.params.eid}/${this.$route.params.sid}` });
      });
      this.togglePageLoader(false);
    },
    async load(enter_area) {
      this.togglePageLoader(true);
      await this.setEnterBlockOptions(enter_area);
      await this.getInternForm({
        type: this.formType,
        params: {
          year: this.$route.params.year,
          enterprise_id: this.$route.params.eid,
          student_id: this.$route.params.sid,
        }
      });
      if (Object.keys(this.currentInternFormGetter).length > 0) {
        this.isEmpty = false;
        enter_area.set_form_data(this.currentInternFormGetter);
      } else {
        this.load_enter_area_top_data(enter_area);
      }
      this.internContentPlanOuterEl = enter_area.get_outer_el_by_key('intern_content_plan');
      this.append_plan_list(this.currentInternFormGetter.intern_content_plan);
      this.togglePageLoader(false);
    },
    async load_enter_area_top_data(enterAreaTop) {
      await this.getInternRecordList();
      const curStudent = this.currentInternRecordListGetter.find(record => record.student_id == this.$route.params.sid && record.enterprise_id == this.$route.params.eid);
      if (curStudent) {
        enterAreaTop.set_form_data({
          department_id: curStudent.department_id,
          student_account: curStudent.student_account,
          student_name: curStudent.student_name,
          internship: curStudent.enterprise_name
        });

      }
    },
    async setEnterBlockOptions(enter_area) {
      let { dept_options, dept_values } = await getDeptOptions();
      enter_area.set_enter_block_options('department_id', dept_options, dept_values);
      this.dept = { dept_options, dept_values };
    },
    append_plan_list(plan_list_form_data) {
      if (Array.isArray(plan_list_form_data) && plan_list_form_data.length) {
        plan_list_form_data.forEach(plan_item_form_data => {
          this.append_plan_item(plan_item_form_data);
        });
      }
      else {
        this.append_plan_item();
      }
    },
    append_plan_item(plan_item_form_data) {
      if (!this.internContentPlanOuterEl) return;
      let el = $('<div class="plan_item">').appendTo(this.internContentPlanOuterEl);
      let index = this.internContentPlanEnterArea.length;
      let plan_item_blueprint = this.get_plan_item_blueprint(index, el);
      let plan_enter_area = new enter_area(el[0], plan_item_blueprint, this.editType == 'view');
      this.$refs.intern_form.setDatetimePopup(plan_enter_area);
      this.internContentPlanEnterArea[index] = plan_enter_area;
      plan_enter_area.set_form_data(plan_item_form_data);
    },
    get_plan_item_blueprint(index, el) {
      let plan_item_blueprint = [
        {
          type: 'outer',
          div: 4,
          blocks: [
            { key: 'start_time', label: '請選擇區間：', type: 'output_button', custom_type: 'date', placeholder: '開始時間', icon: 'date' },
            { key: 'end_time', type: 'output_button', custom_type: 'date', placeholder: '結束時間', icon: 'date' },
          ],
        },
        { key: 'intern_content', label: '實習課程內涵：', placeholder: '請輸入實習課程內涵', type: 'textarea', div: 'grow', required: true,max_length: 500, },
        { key: 'intern_item', label: '實習具體項目：', placeholder: '請輸入實習具體項目', type: 'textarea', div: 'grow', required: true,max_length: 500, },
      ];
      if (this.editType == 'edit') {
        plan_item_blueprint.push({
          type: 'output_button',
          custom_type: 'add_plan_item',
          div: 'auto',
          class_name: 'add_plan_item_btn',
          click: () => {
            if (this.internContentPlanEnterArea.length - 1 == index) {
              this.append_plan_item();
            }
            else {
              el.remove();
              delete this.internContentPlanEnterArea[index];
            }
          },
        });
      }
      return plan_item_blueprint;
    },
    get_form_sq(blueprint) {
      let form_data = { ...this.currentInternFormGetter };
      blueprint.filter(enter_block => enter_block.key == 'department_id').forEach(enter_block => {
        enter_block.options = this.dept.dept_options;
        enter_block.values = this.dept.dept_values;
      });
      blueprint_form_data_to_str_form_data(blueprint, form_data);
      return InternPlanFormFormat(blueprint, form_data);
    },
    async downloadPdf() {
      let blueprint = JSON.parse(JSON.stringify(InternPlanFormBlueprint));
      let { header_sq, content_sq } = this.get_form_sq(blueprint);
      let pdf_data_url = create_pdf_data_url(3, header_sq, content_sq);
      let el = document.createElement('a');
      el.href = pdf_data_url;
      el.download = `${this.formTitle}.pdf`;
      document.body.appendChild(el);
      el.click();
    },
    async printPdf() {
      let blueprint = JSON.parse(JSON.stringify(InternPlanFormBlueprint));
      let { header_sq, content_sq } = this.get_form_sq(blueprint);
      let new_window_cnt = create_new_window_cnt(3, header_sq, content_sq);
      let new_window = window.open('_blank','','width=841,height=1189');
      new_window.document.write('<body onload="print(); close()">');
      new_window.document.write(new_window_cnt);
      new_window.document.write('</body>');
      new_window.document.close();
    },
  }
}
</script>
